import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 28,
    height: 28,
    fill: "transparent"
  }
});

class IcFilledUser extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 28 28" } >
      <path fillRule="evenodd" clipRule="evenodd" d="M9.33341 16.5C7.83052 16.5 6.38918 17.097 5.32648 18.1597C4.26377 19.2224 3.66675 20.6638 3.66675 22.1667V24.5C3.66675 25.0523 3.94772 25.5 4.5 25.5H23.5C24.0523 25.5 24.3334 25.0523 24.3334 24.5V22.1667C24.3334 20.6638 23.7364 19.2224 22.6737 18.1597C21.611 17.097 20.1696 16.5 18.6667 16.5H9.33341Z" fill="#C27100"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.33337 8.16667C8.33337 5.03705 10.8704 2.5 14 2.5C17.1297 2.5 19.6667 5.03705 19.6667 8.16667C19.6667 11.2963 17.1297 13.8333 14 13.8333C10.8704 13.8333 8.33337 11.2963 8.33337 8.16667Z" fill="#C27100"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcFilledUser);
